/*=========================================================================================
  File Name: moduleUnitGetters.js
  Description: Unit Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
    GetAllFloors(state) {
      return state.floor.data;
    },
  };
  